import { render, staticRenderFns } from "./DaysView.vue?vue&type=template&id=a37cd0f6&scoped=true"
import script from "./DaysView.vue?vue&type=script&lang=js"
export * from "./DaysView.vue?vue&type=script&lang=js"
import style0 from "./DaysView.vue?vue&type=style&index=0&id=a37cd0f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37cd0f6",
  null
  
)

export default component.exports